
import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { getMiscApplicableService, getMiscSearchList } from "../../Actions/lookupAPI";
import Autocomplete from "react-autocomplete";
import swal from "sweetalert";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { postMiscAttachment, deleteAttachmentInBucket } from "../../Actions/CommonAPI";
import { getFlagList, getClassList, getTypeofShipList, getMiscTypeList, getEquipmentNameListAndId } from "../../Actions/helpersAPI";
import { validateFields } from "../../Utils/utilities";
import MinusIcon from "../../UIComponents/MinusIcon";
import { RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import AddIcon from "../../UIComponents/AddIcon";
import axios from "axios";
import API from "../../helpers/api";
import $ from "jquery";
import i18n from "../DropdownLanguage/i18n";
import { OverlayTrigger, Popover } from "react-bootstrap";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
var fileDatas = [];

class MiscEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      miscinfo: {
        misc: "",
        miscId: 0,
        isDeleted: false,
        modifiedBy: currentuser.name,
        miscType: "",
        typeValue: "",
        typeValueId: 0,
        attachmentName: "",
        attachmentGuid: "",
        equipmentName: "",
        equipmentId: 0,
        capacity: "",
        category: "",
        equipmentType: "",
      },
      file: "",
      fileName: "",
      modalIsOpen: false,
      ApplicableServices: [],
      ApplicableServicesList: [],
      ServiceTypeList: [],
      selectedServiceYears: [],
      isMiscNew: true,
      AddServiceYear: [
        {
          miscApplicableServiceId: 0,
          miscId: 0,
          Id: 0,
          serviceTypeId: 0,
          equipmentId: 0,
          equipmentName: "",
          capacity: "",
          category: "",
          equipmentType: "",
          type: "",
          typeValueId: 0,
          typeValue: "",
          serviceType: "",
          servicetypelist: [],
          isShore: false,
          radioButton: "",
          isDeleted: false,
          modifiedBy: currentuser.email
        },
      ],
      openTypeValue: false,
      openEquipment: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.UpdateMisc = this.UpdateMisc.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.autocompleteRef = React.createRef();
  }
  componentDidUpdate() {
    window.onpopstate = (e) => {
      this.props.dispatch({ type: "ShowSidePan", data: false });
    };
  }
  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(getEquipmentNameListAndId());
    dispatch(getFlagList());
    dispatch(getMiscTypeList());
    dispatch(getClassList("class"));
    dispatch(getTypeofShipList("typeofship"));
    dispatch({ type: "SubBannerTitle", data: "Misc" });
    axios.get(`${API.GetServiceTypeList}`).then((res) => {
      let list = [];
      let serviceTypeList = [];
      res.data.map((item, index) => {
        let listItem = item.serviceTypes.split(" ");
        let order = (listItem[0]);
        let id = item.id;
        list.push({
          id,
          order,
        });
      });

      let mainList = list.sort(function (a, b) {
        return a.order - b.order;
      });
      mainList.map((item, i) => {
        let serviceTypes = item.order + " yearly";
        item = item.id;
        serviceTypeList.push({
          item,
          serviceTypes,
        });
      });
      this.state.AddServiceYear[0].servicetypelist = serviceTypeList;
      this.setState({ ServiceTypeList: serviceTypeList });
    });
    dispatch(getMiscApplicableService(match.params.id));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      LookupDetails,
      MiscAttachment,
      match,
      dispatch,
      GetMiscApplicableService,
      MiscApplicableServices,
      MiscapplicableServiceType,
    } = nextProps;
    const { params } = match;
    const { type } = params;
    if (LookupDetails && LookupDetails !== "") {
      prevState.miscinfo.misc = LookupDetails.lookUpName;
      prevState.miscinfo.miscId = LookupDetails.lookUpId;
      prevState.miscinfo.miscType = LookupDetails.miscType;
      prevState.miscinfo.attachmentGuid = LookupDetails.miscAttachmentGuid;
      prevState.miscinfo.attachmentName = LookupDetails.miscAttachmentName;
      prevState.fileName = LookupDetails.miscAttachmentName;
      dispatch({ type: "MiscDetails", data: "" });
    }
    if (MiscAttachment) {
      prevState.miscinfo.attachmentName = MiscAttachment.FileName;
      prevState.miscinfo.attachmentGuid = MiscAttachment.Guid;
      dispatch({ type: "postMiscAttachmentUploadSuccess", data: null });
    }
    if (prevState.file !== "") {
      dispatch(postMiscAttachment(prevState.file));
      prevState.file = "";
    }
    if (GetMiscApplicableService && GetMiscApplicableService !== "") {
      prevState.ApplicableServicesList =
        GetMiscApplicableService &&
        GetMiscApplicableService.map((u) => {
          let data = {
            miscApplicableServiceId: u.miscApplicableServiceId,
            miscId: u.miscId,
            type: u.type,
            equipmentId: u.equipmentId,
            equipmentName: u.equipmentName,
            capacity: u.capacity,
            category: u.category,
            equipmentType: u.equipmentType,
            typeValueId: u.typeValueId,
            typeValue: u.typeValue,
            serviceType: u.serviceType,
            serviceTypeId: u.serviceTypeId,
            isShore: u.isShore,
            radioButton: u.isShore ? "Shore" : "Ship",
            isDeleted: false,
            modifiedBy: currentuser.email,
          };
          return data;
        });
      dispatch({ type: "getMiscApplicableServiceSuccess", data: "" });
    }
    if (MiscApplicableServices) {
      prevState.ApplicableServicesList = MiscApplicableServices;
    }
    if (
      MiscapplicableServiceType &&
      MiscapplicableServiceType !== "" &&
      prevState.ApplicableServices &&
      prevState.ApplicableServices.length === 0
    ) {
      dispatch({ type: "getServiceTypeIntervalListMiscSuccess", data: "" });
      prevState.ApplicableServices =
        MiscapplicableServiceType.length &&
        MiscapplicableServiceType.map((d, i) => {
          let obj = {
            miscApplicableServiceId: 0,
            serviceType: d.serviceType,
            serviceTypeId: d.serviceTypeId,
            equipmentId: prevState.miscinfo.equipmentId,
            equipmentName: prevState.miscinfo.equipmentName,
            capacity: prevState.miscinfo.capacity,
            category: prevState.miscinfo.category,
            equipmentType: prevState.miscinfo.equipmentType,
            type: prevState.miscinfo.miscType,
            typeValueId: d.typeValueId,
            typeValue: d.typeValue,
            isShore: false,
            radioButton: "",
            isDeleted: false,
            modifiedBy: currentuser.email,
            miscId: parseInt(match.params.id),
          };
          return obj;
        });
    }
  }
  UpdateMisc() {
    let currentuser = JSON.parse(localStorage.getItem("currentUser"));
    const { match, dispatch, t } = this.props;
    const { params } = match;
    const { type } = params;
    const { misc, miscId } = this.state.miscinfo;
    if (this.state.miscinfo.misc !== "" && this.state.miscinfo.miscType !== "") {
      let url1 = `${API.miscExist}?MiscName=${this.state.miscinfo.misc}&MiscId=${this.state.miscinfo.miscId}&Type=${this.state.miscinfo.miscType}`;
      axios.get(url1).then((response) => {
        if (response.data === true) {
          let lookup = {
            lookUpId: miscId,
            lookUpToUpdate: "lookup",
            lookUpType: "misc",
            lookUpName: misc,
            isDeleted: false,
            miscAttachmentGuid: this.state.miscinfo.attachmentGuid,
            miscAttachmentName: this.state.miscinfo.attachmentName,
            modifiedBy: currentuser.name,
            IntervalYear: 0,
            miscType: this.state.miscinfo.miscType,
          };
          let url = `${API.postlookup}`;
          axios
            .put(url, lookup)
            .then((response) => {
              if (response.data) {
                let url1 = `${API.putMiscApplicableService}`;
                axios
                  .put(url1, this.state.ApplicableServicesList)
                  .then((res) => {
                    let searchData = {
                      LookUpToSearch: "misc",
                      LookUpName: "",
                      PageNumber: 1,
                      PageSize: 20,
                    };

                    if (fileDatas.length > 0) {
                      this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                      fileDatas = [];
                    }
                    dispatch(getMiscSearchList(searchData));
                    this.hideSidePanel();
                    toast.success(`${t("CommonText.CommonUpdate")}`, {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                    dispatch({
                      type: "MiscApplicableServices",
                      data: [],
                    });
                    dispatch({
                      type: "getMiscApplicableServiceSuccess",
                      data: [],
                    });
                    dispatch({
                      type: "postMiscApplicableServiceSuccess",
                      data: res.data,
                    });
                  })
                  .catch((error) => {
                    swal("Error!", "Something went wrong. Please try again.", "warning");
                    dispatch({
                      type: "postMiscApplicableServiceFailure",
                      error: "ERROR",
                    });
                  });
              }
              dispatch({
                type: "putMiscDetailSuccess",
                data: response.data,
              });
            })
            .catch((error) => {
              swal("Error!", "Something went wrong. Please try again.", "warning");
              dispatch({
                type: "putMiscDetailFailure",
                error: "ERROR",
              });
            });
        }
        else if (response.data === false) {
          swal(
            "Error!",
            `${t("MiscScreenContent.WarningMsg")}`,
            "warning"
          );
          this.state.miscinfo.misc = "";
          this.setState({});
        }
        dispatch({
          type: "getMiscExistListSuccess",
          data: response.data,
        });

      })
        .catch((error) => {
          dispatch({
            type: "getMiscExistListFailure",
            data: "error",
          });
        });
    } else if (this.state.miscinfo.misc === "" && this.state.miscinfo.miscType === "") {
      swal("Error!", "Misc name and Misc type is mandatory.", "warning");
    } else if (this.state.miscinfo.misc === "") {
      swal("Error!", "Misc name is mandatory.", "warning");
    } else if (this.state.miscinfo.miscType === "") {
      swal("Error!", "Misc Type is mandatory.", "warning");
    }
  }
  handleFileInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "fileName") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        this.setState({
          file: e.target.files[0],
          fileName: e.target.files[0].name,
        });
      } else {
        swal(
          "Error!",
          "Please upload the file without special characters.",
          "warning");
        return;
      }
    }
  }
  renderEquipmentTitle(state, val) {
    return (
      state?.equipmentName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }
  ClearInput() {
    // this.props.dispatch(deleteAttachmentInBucket(this.state.miscinfo.attachmentGuid,this.state.miscinfo.attachmentName));

    let obj = {
      filename: this.state.miscinfo.attachmentName,
      guid: this.state.miscinfo.attachmentGuid,
    }
    fileDatas.push(obj);
    this.state.miscinfo.attachmentName = "";
    this.state.miscinfo.attachmentGuid = "";
    this.state.file = "";
    this.state.fileName = "";
    this.setState({});
  }
  renderMiscTitle(state, val) {
    return (
      state?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }
  handleInputChange(e, field) {
    let nodeName = e.target.name;
    this.state.miscinfo[field] = e.target.value;
    this.setState({});

  }

  handleRadioButtonChanges = (e, i) => {
    var lineitems = this.state.AddServiceYear;
    lineitems[i][e.target.name] = e.target.value;
    if (e.target.value === "Shore") {
      lineitems[i]["isShore"] = true;
    } else {
      lineitems[i]["isShore"] = false;
    }
    this.setState({ AddServiceYear: lineitems });
  };
  showMiscModal = (MiscId, isMiscNew, EquipId) => {
    var arrayStroage = this.state.ApplicableServicesList;
    var arrayLength = arrayStroage.length;
    if (MiscId > 0) {
      let response = this.state.ApplicableServicesList.filter((item) => (item.Id === MiscId && item.equipmentId === EquipId) || (item.miscApplicableServiceId === MiscId && item.equipmentId === EquipId));
      let editModelDetails = response[0];
      var lineitems = this.state.AddServiceYear;
      lineitems &&
        lineitems.map((a, i) => {
          a.miscApplicableServiceId = editModelDetails.miscApplicableServiceId;
          a.miscId = this.state.miscinfo.miscId;
          a.typeValue = editModelDetails.typeValue;
          a.type = this.state.miscinfo.miscType;
          a.Id = parseInt(editModelDetails.Id || editModelDetails.miscApplicableServiceId);
          a.equipmentId = editModelDetails.equipmentId;
          a.equipmentName = editModelDetails.equipmentName;
          a.capacity = editModelDetails.capacity;
          a.category = editModelDetails.category;
          a.equipmentType = editModelDetails.equipmentType;
          a.serviceTypeId = editModelDetails.serviceTypeId;
          a.serviceType = editModelDetails.serviceType;
          a.radioButton = editModelDetails.isShore ? "Shore" : "Ship";
          a.isDeleted = false;
          a.modifiedBy = currentuser.email;
        });
      let arrayYears = [];
      let result = [];
      let currentvalue = [];
      let result1 = this.state.ServiceTypeList;
      let deletedArray = this.state.ApplicableServicesList;
      currentvalue = result1.filter((i) => i.item === editModelDetails.serviceTypeId)
      let index = deletedArray.map((item) => item.isDeleted).indexOf(true);
      if (deletedArray.length !== 0) {
        let result2 = deletedArray.filter((i) => i.equipmentId === editModelDetails.equipmentId && i.typeValue === editModelDetails.typeValue);
        result2.map((j) => { arrayYears.push(j.serviceTypeId); });
      } else {
        let result2 = this.state.ApplicableServicesList.filter((i) => i.equipmentId === editModelDetails.equipmentId && i.typeValue === editModelDetails.typeValue);
        result2.map((j) => {
          arrayYears.push(j.serviceTypeId);
        });
      }
      result = result1.filter(function (obj) {
        return arrayYears.indexOf(obj.item) === -1;
      });
      let finalResult = [...currentvalue, ...result];
      let list = [];
      let newServiceTypeList = []
      finalResult.map((j, index) => {
        let listItem = j.serviceTypes.split(" ");
        let order = (listItem[0])
        let id = j.item;
        list.push({ id, order });
      });
      let mainList = list.sort(function (a, b) {
        return a.order - b.order;
      })
      mainList.map((item, i) => {
        let serviceTypes = item.order + " yearly";
        item = item.id;
        newServiceTypeList.push({
          item,
          serviceTypes,
        });
      });
      this.state.AddServiceYear[0].servicetypelist = newServiceTypeList;
      this.setState(
        {
          modalIsOpen: !this.state.modalIsOpen,
          isMiscNew: isMiscNew,
          AddServiceYear: lineitems,
        },
        () => console.log(this.state.isMiscNew)
      );
    } else {
      var lineitems = this.state.AddServiceYear;
      lineitems &&
        lineitems.map((a, i) => {
          a.Id = arrayLength === 0 ? arrayLength + 1 : arrayLength > 0 ? arrayLength + 1 : 0;
        });
      this.setState(
        {
          isMiscNew: isMiscNew,
          AddServiceYear: lineitems,
          modalIsOpen: !this.state.modalIsOpen,
        },
        () => {
          console.log(this.state.AddServiceYear);
          this.ClearServiceYear();
        }
      );
    }
  };
  addApplicableType = () => {
    const { dispatch } = this.props;
    if (this.state.AddServiceYear.length > 0) {
      let isValidMiscCharge = this.miscChargeValidation();
      if (!isValidMiscCharge) {
        return;
      }
    }
    let GetMisc = this.state.ApplicableServicesList;
    let temp = [];
    if (this.state.AddServiceYear[0]?.miscApplicableServiceId !== 0) {
      temp = GetMisc.filter((j) => j.miscApplicableServiceId === this.state.AddServiceYear[0]?.Id);
    } else {
      temp = GetMisc.filter((j) => (j.Id === this.state.AddServiceYear[0]?.Id) && (j.equipmentId === this.state.AddServiceYear[0]?.equipmentId));
    }
    if (temp.length > 0) {
      GetMisc.forEach((ele, index) => {
        if (ele.miscApplicableServiceId !== 0) {
          if (ele.miscApplicableServiceId === this.state.AddServiceYear[0]?.Id) {
            GetMisc[index] = this.state.AddServiceYear[0];
          }
        } else {
          if ((ele.Id === this.state.AddServiceYear[0]?.Id) && (ele.equipmentId === this.state.AddServiceYear[0]?.equipmentId)) {
            GetMisc[index] = this.state.AddServiceYear[0];
          }
        }
      });
    } else {
      GetMisc.push(...this.state.AddServiceYear);
    }

    dispatch({
      type: "MiscApplicableServices",
      data: this.state.ApplicableServicesList,
    });
    console.log("Final Class list", this.state.ApplicableServicesList)
    this.state.miscinfo.equipmentName = "";
    this.state.miscinfo.equipmentId = 0;
    this.state.miscinfo.capacity = "";
    this.state.miscinfo.category = ""
    this.setState({ modalIsOpen: false }, () => {
      this.ClearServiceYear();
    });
  };
  miscChargeValidation() {
    const { t } = this.props;
    let validateField = [];
    let inValidComponent = [];
    let length = this.state.AddServiceYear.length;
    let miscCharges = this.state.AddServiceYear.filter(
      (item) => item.isDeleted === false
    );
    if (
      $("#chargeDescription0").val() === "" ||
      miscCharges[0].radioButton === ""
    ) {
      if ($("#chargeDescription0").val() === "") {
        $("#chargeDescription0ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#chargeDescription0ErrMsg").text("");
      }
      if (miscCharges[0].radioButton === "") {
        $("#isUnitPrice0ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#isUnitPrice0ErrMsg").text("");
      }
      return;
    } else {
      $("#chargeDescription0ErrMsg").text("");
      $("#isUnitPrice0ErrMsg").text("");
    }
    let indexFrom =
      $("#chargeDescription0").val() === "" && miscCharges[0].radioButton === ""
        ? 1
        : 0;
    miscCharges.forEach((row, index) => {
      if (index >= indexFrom) {
        validateField.push({ Id: `chargeDescription${index}`, Type: "text" });
        if (row.radioButton == "") {
          inValidComponent.push(`isUnitPrice${index}`);
          $("#isUnitPrice" + index + "ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
        } else {
          $("#isUnitPrice" + index + "ErrMsg").text("");
          var itemIndex = inValidComponent.indexOf(`isUnitPrice${index}`);
          if (itemIndex != -1) {
            inValidComponent.splice(itemIndex, 1);
          }
        }
      }
    });
    const validationResult = validateFields(validateField, true);
    validationResult.InValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
    });
    validationResult.ValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text("");
    });
    if (validationResult.IsValid === true && inValidComponent.length === 0) {
      return true;
    } else {
      return false;
    }
  }
  AddNewServiceYear() {
    let isValidMiscCharge = this.miscChargeValidation();
    if (!isValidMiscCharge) {
      return;
    }
    let result = [];
    let selectedValue = [];
    let result1 = this.state.ServiceTypeList;
    var arrayStroage = this.state.AddServiceYear;
    var arrayLength = 0;
    selectedValue = this.state.ApplicableServicesList.filter(item => item.equipmentId === arrayStroage[0].equipmentId && item.typeValue === arrayStroage[0].typeValue)
    let result2 = this.state.selectedServiceYears;
    console.log("selected", this.state.selectedServiceYears);
    if (selectedValue.length !== 0) {
      selectedValue.map((i) => (
        result2.push(i.serviceTypeId)
      ))
    }
    result = result1.filter(function (obj) {
      return result2.indexOf(obj.item) === -1;
    });

    if (this.state.ApplicableServicesList.length > 0 && this.state.AddServiceYear.length > 0) {
      arrayLength = this.state.ApplicableServicesList.length + this.state.AddServiceYear.length;
    }
    else if (this.state.ApplicableServicesList.length > 0) {
      arrayLength = this.state.ApplicableServicesList.length;
    } else {
      arrayLength = this.state.AddServiceYear.length;
    }

    console.log("service years:", result, arrayLength);
    this.setState({
      AddServiceYear: [
        ...this.state.AddServiceYear,
        {
          miscApplicableServiceId: 0,
          miscId: this.state.miscinfo.miscId,
          Id: arrayLength + 1,
          serviceTypeId: 0,
          type: this.state.miscinfo.miscType,
          typeValue: arrayStroage[0].typeValue,
          equipmentId: arrayStroage[0].equipmentId,
          equipmentName: arrayStroage[0].equipmentName,
          capacity: arrayStroage[0].capacity,
          category: arrayStroage[0].category,
          equipmentType: arrayStroage[0].equipmentType,
          servicetypelist: result,
          isShore: false,
          radioButton: "",
          isDeleted: false,
          modifiedBy: currentuser.email,
        },
      ],
    });
  }
  handleSelectYear = (e, i) => {
    let value = parseInt(e.target.value);
    let ServiceTypeList = this.state.ServiceTypeList.filter(
      (i) => i.item === value
    );
    let x = this.state.selectedServiceYears;
    x.push(value);
    this.setState({ selectedServiceYears: x });
    console.log("selected", this.state.selectedServiceYears);
    let AddServiceYear = this.state.AddServiceYear;
    AddServiceYear[i][e.target.name] = parseInt(e.target.value);
    AddServiceYear[i]["serviceType"] = ServiceTypeList[0].serviceTypes;
    this.setState({ AddServiceYear });
  };
  DeleteServiceYear(index) {
    const serviceCharges = [...this.state.AddServiceYear];
    serviceCharges.splice(index, 1);
    if (this.state.selectedServiceYears.length > 1) {
      const selectedServiceYear = [...this.state.selectedServiceYears];
      selectedServiceYear.splice(index, 1);
      this.state.selectedServiceYears = selectedServiceYear;
      this.setState({});
    }
    this.state.AddServiceYear = serviceCharges;
    this.setState({});
  }
  ClearServiceYear() {
    var arrayStroage = this.state.ApplicableServicesList;
    var arrayLength = arrayStroage.length;
    this.setState({
      AddServiceYear: [
        {
          miscApplicableServiceId: 0,
          miscId: this.state.miscinfo.miscId,
          Id: arrayLength === 0 ? arrayLength + 1 : arrayLength > 0 ? arrayLength + 1 : 0,
          serviceTypeId: 0,
          equipmentId: this.state.miscinfo.equipmentId,
          equipmentName: this.state.miscinfo.equipmentName,
          capacity: this.state.miscinfo.capacity,
          category: this.state.miscinfo.category,
          equipmentType: this.state.miscinfo.equipmentType,
          typeValue: this.state.AddServiceYear[0].typeValue,
          type: this.state.miscinfo.miscType,
          serviceType: "",
          servicetypelist: this.state.AddServiceYear[0].servicetypelist,
          isShore: false,
          radioButton: "",
          isDeleted: false,
          modifiedBy: currentuser.email

        },
      ],
      selectedServiceYears: [],
    });
  }


  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  renderdelete(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  deleteApplicableType = (item) => {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            item.isDeleted = true;
            item.modifiedBy = currentuser.email;
            this.setState({});
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { },
        },
      ],
    });
  };
  handleSelectChange(value, field, item) {
    this.state.miscinfo[field] = value;
    var lineitems = this.state.AddServiceYear;
    lineitems &&
      lineitems.map((a, i) => {
        a.typeValue = value;
      });
    this.setState({ AddServiceYear: lineitems });
  }
  handleEquipmentSelectChange(value, field, item) {
    if (this.state.miscinfo.typeValue !== "") {
      this.state.miscinfo[field] = value;
      this.state.miscinfo.equipmentId = item.equipmentId;
      this.state.miscinfo.category = item.category;
      this.state.miscinfo.capacity = item.capacity;
      this.state.miscinfo.equipmentType = item.equipmentType;
      if (this.state.ApplicableServicesList.length > 0) {
        let arrayYears = [];
        let result = [];
        let result1 = this.state.ServiceTypeList;
        let deletedArray = this.state.ApplicableServicesList;
        let index = deletedArray.map((item) => item.isDeleted).indexOf(true);
        if (deletedArray.length !== 0) {
          let result2 = deletedArray.filter((i) => i.equipmentId === item.equipmentId && i.typeValue === this.state.miscinfo.typeValue);
          if (result2.length !== 0) {
            result2.map((j) => { arrayYears.push(j.serviceTypeId); });
          }
        } else {
          let result2 = this.state.ApplicableServicesList.filter((i) => i.equipmentId === item.equipmentId && i.typeValue === this.state.miscinfo.typeValue);
          if (result2.length !== 0) {
            result2.map((j) => { arrayYears.push(j.serviceTypeId); });
          }
        }
        if (arrayYears.length !== 0) {
          result = result1.filter(function (obj) { return arrayYears.indexOf(obj.item) === -1; });
          this.state.AddServiceYear[0].servicetypelist = result;
          this.setState({})
        } else {
          this.state.AddServiceYear[0].servicetypelist = result1;
          this.setState({})
        }
      }
      var lineitems = this.state.AddServiceYear;
      lineitems &&
        lineitems.map((a, i) => {
          a.miscId = this.state.miscinfo.miscId;
          a.equipmentId = item.equipmentId;
          a.equipmentName = value;
          a.capacity = item.capacity;
          a.category = item.category;
          a.equipmentType = item.equipmentType;
          a.typeValue = lineitems[0].typeValue;
        });

      this.setState({ AddServiceYear: lineitems });
      this.autocompleteRef.current.blur();
      this.showMiscModal(0, true);
    } else {
      swal("Error!", `Please select the ${this.state.miscinfo.miscType}.`, "warning");
    }
  }
  handleInputChanges(e, field) {
    if (field === "equipmentName") {
      this.state.miscinfo[field] = e.target.value;
      this.setState({})
    }
  }

  hideSidePanel = () => {
    fileDatas = [];
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/LookUpMisc");
    this.props.dispatch({ type: "MiscApplicableServices", data: [], });
    this.props.dispatch({ type: "getMiscApplicableServiceSuccess", data: [], });
  };



  render() {
    const { t } = this.props;
    const { ApplicableServices } = this.state;
    return (
      <div className="pb-3">
        <Modal
          size="md"
          show={this.state.modalIsOpen}
          onHide={() => this.setState({ modalIsOpen: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">
              {t("content.Servicetype")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.AddServiceYear.map((x, index) => {
              return (
                <>
                  <div className="row pt-2">
                    <div className="col-lg-5">
                      <select
                        className="form-control serviceyear"
                        name="serviceTypeId"
                        id={`chargeDescription${index}`}
                        value={x.serviceTypeId == 0 ? "" : x.serviceTypeId}
                        onChange={(e) => this.handleSelectYear(e, index, false)}
                      >
                        <option className="newservice" value="">{t("ClassScreen.SelectServiceYear")}</option>
                        {x &&
                          x?.servicetypelist?.map((name) => (
                            <option value={name.item}>
                              {name.serviceTypes}
                            </option>
                          ))}
                      </select>
                      <span
                        id={`chargeDescription${index}ErrMsg`}
                        className="spanErrMsg ml-2"
                      ></span>
                    </div>

                    <div className="col-lg-5" style={{ lineHeight: "0px" }}>
                      <RadioGroup
                        className="radio-value"
                        row
                        name="radioButton"
                        id={`isUnitPrice${index}`}
                        value={x.radioButton}
                        onChange={(e) =>
                          this.handleRadioButtonChanges(e, index)
                        }
                      >
                        <FormControlLabel
                          className="mt-0"
                          style={{ marginBottom: "11px" }}
                          value="Ship"
                          control={<Radio color="default" size="small" />}
                          label={t("Generateservicerequestcontent.Ship")}
                        />
                        <FormControlLabel
                          className="mt-0"
                          style={{ marginBottom: "11px" }}
                          value="Shore"
                          control={<Radio color="default" size="small" />}
                          label={t("Generateservicerequestcontent.Shore")}
                        />
                      </RadioGroup>
                      <span
                        id={`isUnitPrice${index}ErrMsg`}
                        className="spanErrMsg ml-2"
                      ></span>
                    </div>
                    <div
                      className={`col-lg-2 ${this.state.isMiscNew ? "" : "d-none"
                        }`}
                    >
                      <div
                        className={`mr-3 pl-1 ${index === 0 ? "d-none" : ""}`}
                      >
                        <div
                          className="flex"
                          onClick={() => this.DeleteServiceYear(index)}
                        >
                          <MinusIcon />
                        </div>
                      </div>
                      <div
                        className={`mr-3 pl-1 ${index === 0 ? "" : "d-none"}`}
                      >
                        <div
                          className="flex"
                          onClick={() => this.AddNewServiceYear()}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}

            <div
              className="form-group search-btn-col mt-4"
              style={{ textAlign: "end" }}
            >
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                type="submit"
                onClick={() => this.addApplicableType()}
              >
                {this.state.isMiscNew ? `${t("ComplianceandBudgetScreen.Submit")}` : `${t("EquipmentServiceTypes.Update")}`}
              </button>
              <button
                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                type="button"
                onClick={() => this.showMiscModal(0, true)}
              >
                {" "}
                {t("ComplianceandBudgetScreen.Cancel")}{" "}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {this.renderCardData()}
      </div>
    );
  }

  renderCardData() {
    const { showSidePane, arraylist, EquipmentNameListAndId, Loading, t, flagList, ClassList, TypeofShipList, MiscTypeofList } = this.props;
    const { ApplicableServicesList } = this.state;
    const isArabic = i18n.language === 'arab'
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3">
          <div className="col-lg-12">
            <div className="panel-box search-filter-box">
              <div
                className="card MM-card-header mt-2"
                style={{ backgroundColor: "white" }}>
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}>
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}>
                    {t("MiscScreenContent.EditMisc")}
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-4">
                  <label className="form-label required">{t("MiscScreenContent.Title")}</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="Class"
                    value={this.state.miscinfo.misc}
                    placeholder={t("MiscScreenContent.Title")}
                    onChange={(e) => this.handleInputChange(e, "misc")}></input>
                </div>
                <div className="col-lg-4">
                  <label className="form-label required">{t("ComplianceandBudgetScreen.Type")}</label>
                  <br></br>
                  <select className="form-control" name="flag" value={this.state.miscinfo.miscType} onChange={(e) => this.handleInputChange(e, "miscType")} disabled={true}>
                    <option value="">{t("EditEquipmentScreenContent.SelectType")}</option>
                    {MiscTypeofList &&
                      MiscTypeofList.map((Miscname) => (
                        <option value={Miscname}>{Miscname}</option>
                      ))}
                  </select>
                </div>
                {this.state.miscinfo.miscType === "Ship Type" ?
                  <div className="col-lg-4">
                    <div className="autocomplete-wrappers"
                      style={{
                        zIndex: this.state.openTypeValue && !Loading
                          ? 99999 : 0,
                      }}>
                      <label className="form-label"> {t("TopPaneContent.TypeofShip")}</label>
                      <br></br>
                      <Autocomplete
                        contentEditable={true}
                        open={!Loading ? this.state.openTypeValue : false}
                        onMenuVisibilityChange={(isOpen) => {
                          this.state.openTypeValue = isOpen;
                          this.setState({});
                        }}
                        value={this.state.miscinfo.typeValue}
                        inputProps={{ placeholder: `${t("ShipManagementContent.SelectTypeofShip")}` }}
                        items={TypeofShipList?.list ?? []}
                        getItemValue={(item) => item}
                        shouldItemRender={this.renderMiscTitle.bind(this)}
                        renderMenu={(item) => (
                          <div className="dropdown">{item}</div>
                        )}
                        renderItem={(item, isHighlighted) => (
                          <div
                            className={`items ${isHighlighted ? "selected-items" : ""
                              }`}>{item}</div>
                        )}
                        onChange={(e) =>
                          this.handleInputChange(e, "typeValue")
                        }
                        onSelect={(value, item) =>
                          this.handleSelectChange(value, "typeValue", item)
                        }
                      />
                    </div>
                  </div> : this.state.miscinfo.miscType === "Flag Type" ?
                    <div className="col-lg-4">
                      <div className="autocomplete-wrappers"
                        style={{
                          zIndex: this.state.openTypeValue && !Loading ? 99999 : 0,
                        }}>
                        <label className="form-label">{t("TopPaneContent.Flag")}</label>
                        <br></br>
                        <Autocomplete
                          contentEditable={true}
                          open={!Loading ? this.state.openTypeValue : false}
                          onMenuVisibilityChange={(isOpen) => {
                            this.state.openTypeValue = isOpen;
                            this.setState({});
                          }}
                          value={this.state.miscinfo.typeValue}
                          inputProps={{ placeholder: `${t("ShipManagementContent.SelectFlag")}` }}
                          items={flagList ?? []}
                          getItemValue={(item) => item}
                          shouldItemRender={this.renderMiscTitle.bind(this)}
                          renderMenu={(item) => (
                            <div className="dropdown">{item}</div>
                          )}
                          renderItem={(item, isHighlighted) => (
                            <div
                              className={`items ${isHighlighted ? "selected-items" : ""
                                }`}> {item}</div>)}
                          onChange={(e) =>
                            this.handleInputChange(e, "typeValue")}
                          onSelect={(value, item) =>
                            this.handleSelectChange(value, "typeValue", item)}
                        />
                      </div>
                    </div> :
                    this.state.miscinfo.miscType === "Class Type" ?
                      <div className="col-lg-4">
                        <div className="autocomplete-wrappers"
                          style={{
                            zIndex: this.state.openTypeValue && !Loading ? 99999 : 0,
                          }}>
                          <label className="form-label">{t("TopPaneContent.Class")}</label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            open={!Loading ? this.state.openTypeValue : false}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openTypeValue = isOpen;
                              this.setState({});
                            }}
                            value={this.state.miscinfo.typeValue}
                            inputProps={{ placeholder: `${t("TopPaneContent.Class")}` }}
                            items={ClassList ?? []}
                            getItemValue={(item) => item}
                            shouldItemRender={this.renderMiscTitle.bind(this)}
                            renderMenu={(item) => (
                              <div className="dropdown">{item}</div>
                            )}
                            renderItem={(item, isHighlighted) => (
                              <div
                                className={`items ${isHighlighted ? "selected-items" : ""
                                  }`}>
                                {item}</div>
                            )}
                            onChange={(e) =>
                              this.handleInputChange(e, "typeValue")
                            }
                            onSelect={(value, item) =>
                              this.handleSelectChange(value, "typeValue", item)
                            }
                          />
                        </div>
                      </div> : <></>}
                <div className="col-lg-4">
                  <label className="form-label">{t("FlagScreen.Attachment")}</label>
                  <br></br>
                  <div class="input-group ">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        {t("CommonText.BrowseFile")}
                        <input
                          type="file"
                          id="files"
                          name="fileName"
                          style={{ marginRight: 40 }}
                          onChange={(e) => this.handleFileInputChange(e)}
                          onClick={(event) => {
                            event.currentTarget.value = null;
                          }}
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      placeholder={t("CommonText.Nofilechoosen")}
                      value={this.state.fileName}
                    />
                    {this.state.fileName ? (
                      <div
                        class="input-group-append"
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-times input-group-text padding-top-10px"
                          aria-hidden="true"
                          onClick={() => this.ClearInput()}
                        ></i>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="search-filter-box">
                <div style={{ display: this.state.miscinfo.miscType === "Ship Type" || this.state.miscinfo.miscType === "Class Type" || this.state.miscinfo.miscType === "Flag Type" ? "block" : "none" }}>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}>
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}>
                        {t("ClassScreen.ApplicableServices")}
                      </h5>
                    </div>
                  </div>

                  <div className="row search-filter-box">
                    <div className="col-lg-4">
                      <div
                        className="autocomplete-wrappers"
                        style={{
                          zIndex:
                            this.state.openEquipment && !Loading ? 99999 : 0,
                        }}
                      >
                        <label className="form-label">{t("ShipEquipmentStatusScreen.EquipmentName")}</label>
                        <br></br>
                        <Autocomplete
                          contentEditable={true}
                          ref={this.autocompleteRef}
                          open={!Loading ? this.state.openEquipment : false}
                          onMenuVisibilityChange={(isOpen) => {
                            this.state.openEquipment = isOpen;
                            this.setState({});
                          }}
                          value={this.state.miscinfo.equipmentName}
                          inputProps={{ placeholder: `${t("ShipEquipmentStatusScreen.EquipmentName")}` }}
                          items={EquipmentNameListAndId ?? []}
                          getItemValue={(item) => item.equipmentName}
                          shouldItemRender={this.renderEquipmentTitle.bind(this)}
                          renderMenu={(item) => (
                            <div className="dropdown">{item}</div>
                          )}
                          renderItem={(item, isHighlighted) => (
                            <div
                              className={`items ${isHighlighted ? "selected-items" : ""
                                }`}
                            >
                              {item.equipmentName}&nbsp; (
                              {item.category &&
                                (item.capacity || item.equipmentType)
                                ? item.category + ","
                                : item.category
                                  ? item.category
                                  : ""}
                              &nbsp;{" "}
                              {item.capacity &&
                                (item.category || item.equipmentType)
                                ? item.capacity + ","
                                : item.capacity
                                  ? item.capacity
                                  : ""}
                              &nbsp;{" "}
                              {item.equipmentType ? item.equipmentType : ""})
                            </div>
                          )}
                          onChange={(e) =>
                            this.handleInputChanges(e, "equipmentName")
                          }
                          onSelect={(value, item) =>
                            this.handleEquipmentSelectChange(value, "equipmentName", item)
                          }
                        />
                      </div>
                    </div>
                  </div>

                  {ApplicableServicesList && ApplicableServicesList.length ? (
                    ApplicableServicesList.map((item, index) => {
                      if (!item.isDeleted) {
                        return (
                          <div
                            className="card m-3"
                            style={{
                              backgroundColor: "#f0f0f0",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <div className="p-3">
                              <div className="resource-list-auth-date">
                                <div className="row">
                                  <div className="col-sm-9 col-md-10 col-9 m-auto">
                                    <div className="row">
                                      <div className="col-sm-4">
                                        <span>
                                          <strong>{this.state.miscinfo.miscType === "Ship Type" ? `${t("TopPaneContent.TypeofShip")}` : this.state.miscinfo.miscType === "Class Type" ? `${t("TopPaneContent.Class")}` : this.state.miscinfo.miscType === "Flag Type" ? `${t("TopPaneContent.Flag")}` : ""}{" "}:{" "} </strong>
                                          {item.typeValue}
                                        </span>
                                      </div>
                                      <div className="col-sm-8">
                                        <span>
                                          <strong>{t("ShipEquipmentStatusScreen.EquipmentName")} : </strong>
                                          {item.equipmentName}&nbsp; (
                                          {item.category &&
                                            (item.capacity || item.equipmentType)
                                            ? item.category + ","
                                            : item.category
                                              ? item.category
                                              : ""}
                                          &nbsp;{" "}
                                          {item.capacity &&
                                            (item.category || item.equipmentType)
                                            ? item.capacity + ","
                                            : item.capacity
                                              ? item.capacity
                                              : ""}
                                          &nbsp;{" "}
                                          {item.equipmentType
                                            ? item.equipmentType
                                            : ""}
                                          )
                                        </span>
                                      </div>
                                      <div className="col-sm-4 mt-1">
                                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                                          <strong>{t("content.Servicetype")}  </strong>
                                          <strong>:</strong>

                                        </span>
                                        {item?.serviceType}
                                      </div>
                                      <div className="col-sm-4 mt-1">
                                        <span>
                                          <strong>{t("ComplianceandBudgetScreen.Type")} : </strong>
                                          {item?.isShore ? "Shore" : "Ship"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-3 col-md-2 col-3 m-auto">
                                    <div className="text-right">
                                      <OverlayTrigger
                                        placement="bottom"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={this.renderedit()}
                                      >
                                        <i
                                          className="fa fa-edit fa-lg click m-1 px-1"
                                          onClick={() =>
                                            this.showMiscModal(item.miscApplicableServiceId || item.Id, false, item.equipmentId)}
                                          aria-hidden="true"
                                          style={{
                                            color: " #1a3464",
                                            fontSize: "1.8rem",
                                          }}
                                        ></i>
                                      </OverlayTrigger>

                                      <OverlayTrigger
                                        placement="bottom"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={this.renderdelete()}
                                      >
                                        <i
                                          className="fa fa-trash click m-1 px-2"
                                          onClick={() =>
                                            this.deleteApplicableType(item)
                                          }
                                          aria-hidden="true"
                                          style={{
                                            color: " #1a3464",
                                            fontSize: "1.8rem",
                                          }}
                                        ></i>
                                      </OverlayTrigger>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })
                  ) : (
                    <div className="card m-3" style={{ overflow: "hidden", position: "relative" }}>
                      <div class="container">
                        <h6 className="resource-list-title no-item-card">
                          {t("CommonText.NoService")}
                        </h6>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.UpdateMisc()}>
                      {" "}
                      {t("EquipmentServiceTypes.Update")}{" "}
                    </button>

                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}>
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    EquipmentNameListAndId: state.MasterScreenReducer.EquipmentNameListAndId || [],
    MiscAttachment: state.lookupReducer.MiscAttachment || null,
    LookupDetails: state.MasterScreenReducer.MiscListDetails,
    serviceTypeList: state.MasterScreenReducer.applicableServiceTypeInterval || [],
    MiscTypeofList: state.MasterScreenReducer.MiscTypeofList,
    ClassList: state.MasterScreenReducer.ClassList,
    TypeofShipList: state.MasterScreenReducer.TypeofShipList,
    flagList: state.MasterScreenReducer.flagList,
    GetMiscApplicableService:
      state.lookupReducer.GetMiscApplicableService || null,
    MiscApplicableServices: state.MasterScreenReducer.MiscApplicableServices,
    Loading: state.PageLoaderReducer.loading,
    MiscapplicableServiceType: state.MasterScreenReducer.MiscapplicableServiceType || null,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MiscEdit));